import React, { Component } from 'react';
import { connect } from 'react-redux';
import SupportTeam from '../SupportTeam';
import { withRouter, Redirect, Prompt } from 'react-router-dom';
import { actionCreators } from '../../store/Login';
import { bindActionCreators } from 'redux';
import { PageHeader, PageHeaderRight, PageHeaderCenter } from '../shared/PageHeader';
import { toast } from 'react-toastify';
import moment from "moment";
import { SingleDatePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import { DateConst, BlankOrderGuideGroup } from '../shared/consts';

class CreateSalesOrderGroup extends Component {
    displayName = CreateSalesOrderGroup.name;

    constructor(props) {
        super(props);

        this.state = {
            storeId: 10,
            isAdmin: false,
            loading: true, // initial state
            isPublished: false,
            currOrder: false,
            salesOrderItems: [],
            salesOrderCart: [],
            stores: [],
            orderGuideDeliveryDate: new Date(),
            orderGuideGroup: BlankOrderGuideGroup,
            isDirty: false,
            HoursOfOperationCheck: false,
            tabIndex: 0,
            submitting: false,
            orderSubmitted: false,
            orderSubmitMessage1: '',
            orderSubmitMessage2: '',
            customDeliveryDate: moment(Date.now() + 1 * 24 * 3600 * 1000),
            startDeliveryDate: moment(),
            deliveryDateMax: moment(),
            salesOrderRefreshRate: undefined,
            refreshId: 0,
            orderCloseWarning: false,
            originalDeliveryDate: moment(Date.now() + 1 * 24 * 3600 * 1000), 
            openDate: undefined,
            closeDate: undefined,
            deepOpenDate: undefined,
            closeOpenDate: undefined,
            columns: [],
            columnsBottom: [],
            frameworkComponents: {
                numericEditor: NumericEditor,
                agColumnHeader: CustomHeader
            },
            onGridReady: function (params) {
            },
            gridApi: [],
            gridApiBottom: [],
            originalLastPublishedDate: "",
            lastPublishedDate: ""
            // this is not used // hasConflicts: false
        };
    }

    componentDidMount = async () => {
        const topOptions = { alignedGrids: [] };
        const bottomOptions = { alignedGrids: [] };

        topOptions.alignedGrids.push(bottomOptions);
        bottomOptions.alignedGrids.push(topOptions);

        this.setState({
            gridApi: topOptions,
            gridApiBottom: bottomOptions
        });

        try {
            var d = new Date();
            d.setDate(d.getDate() + 1);
            d.setHours(0);
            d.setMinutes(0);
            d.setSeconds(0);
            var d2 = moment(d);

            this.setState({ startDeliveryDate: d2 });

            const fetchConfig = {
                method: 'GET', headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
            };
            const response = await fetch('api/OrderGuideGroups/settings', fetchConfig);
            if (response.ok) {
                let data = await response.json();
                let dateNow = new Date();
                let openDate = new Date();
                let closeDate = new Date();

                var startDate = '', endDate = '', startHour = '', startMinute = '', endHour = '', endMinute = '';
                
                if (this.props.isSameDay === true) {
                    startDate = data.orderGuideGroup.sameDayOrderHoO_Start;
                    endDate = data.orderGuideGroup.sameDayOrderHoO_End;
                }
                else {
                    startDate = data.orderGuideGroup.orderHoO_Start;
                    endDate = data.orderGuideGroup.orderHoO_End;
                }

                if (startDate.length < 7) {
                    startDate = '0' + startDate;
                }

                startHour = (startDate.substring(5, 7) === 'pm' && startDate.substring(0, 2) !== '12') ? (parseInt(startDate.substring(0, 2), 10) + 12) : startDate.substring(0, 2);

                if (startDate.substring(5, 7) === 'am' && startDate.substring(0, 2) === '12') {
                    startHour = '00';
                }

                startMinute = startDate.substring(3, 5);

                if (endDate.length < 7) {
                    endDate = '0' + endDate;
                }

                endHour = (endDate.substring(5, 7) === 'pm' && endDate.substring(0, 2) !== '12') ? (parseInt(endDate.substring(0, 2), 10) + 12) : endDate.substring(0, 2);
                endMinute = endDate.substring(3, 5);
                openDate.setHours(startHour);
                openDate.setMinutes(startMinute);
                openDate.setSeconds(0);
                closeDate.setHours(endHour);
                closeDate.setMinutes(endMinute);
                closeDate.setSeconds(0);

                this.setState({
                    orderGuideGroup: data.orderGuideGroup,
                    stores: data.assignedStores,
                    HoursOfOperationCheck: (dateNow > openDate && dateNow < closeDate) ? true : false,
                    openDate: openDate,
                    closeDate: closeDate,
                    deepOpenDate: openDate,
                    deepCloseDate: closeDate
                });

                const fetchConfig = {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                };

                var deliveryDate = moment(Date.now() + 1 * 24 * 3600 * 1000);

                const response2 = await fetch('api/SalesOrder/SalesOrderGroup?orderDate=' + deliveryDate.format(), fetchConfig);
                if (response2.ok) {
                    let data2 = await response2.json();

                    if (data2.salesOrders && data2.salesOrders.length > 0) {

                        this.setState({
                            salesOrderItems: data2.salesOrders,
                            columns: data2.agColumns,
                            columnsBottom: data2.agColumnsBottom,
                            // Pacific time
                            orderGuideDeliveryDate: data2.orderGuideDeliveryDate,
                            // Pacific time
                            originalDeliveryDate: deliveryDate,
                            // Pacific time
                            deliveryDateMax: moment(data2.orderGuideDeliveryDate),
                            // Pacific time
                            originalLastPublishDate: data2.lastPublishedDate,
                            // Pacific time
                            lastPublishedDate: data2.lastPublishedDate
                        });

                        var col = data2.agColumns;
                        var cols = [];

                        for (var i = 0; i < col.length; i++) {

                            var navigatable = (col[i].headerName === "ProductId" ||
                                col[i].headerName === "StoreId" ||
                                col[i].headerName === "Description" ||
                                col[i].headerName === "Price" ||
                                col[i].headerName === "OGC Comments" ||
                                col[i].headerName === "Brand" ||
                                col[i].headerName === "SortValue" ||
                                col[i].headerName === "ProductClass" ||
                                col[i].headerName === "Packaging" ||
                                col[i].headerName === "Group Buyer Notes" ||
                                col[i].headerName === "Total Cases" ||
                                col[i].headerName === "Total Price");

                            if (!navigatable) {
                                cols.push(col[i].field);
                            }
                        }
                        this.setState({ cols: cols });
                    }

                    // Do not set up the warning if the page/component is loaded after close date
                    var now = new Date();
                    var close = this.state.closeDate;

                    if (now < close) {
                        var intervalId = window.setInterval(this.orderSubmisionClosingWarning, 10000);
                        this.setState({ refreshId: intervalId });
                    }
                }
                else {
                    toast.warn(`No Order Guide has been published today for ${this.state.orderGuideGroup.orderGuideGroupName}.`);
                }
            
            }
            else if (response.status === 401) {
                toast.error("Unauthorized.");
                this.props.signOut();
            }
            else {
                toast.error(`Error fetching Order Guide settings.`);
                console.log(`Error fetching Order Guide settings: ${await response.text()}.`);
            }
        }
        catch (e) {
            console.log("Error fetching Order Guide settings: " + e);
        }

        this.setState({ loading: false });
    }

    postOrder = async (isSave) => {
        this.state.gridApi.clearFocusedCell();
        this.setState({ submitting: true });
        toast.warn("Saving all orders...", { autoClose: 10000, hideProgressBar: false });

        const rows = this.state.salesOrderItems;

        if (!this.state.orderGuideGroup.allowMultipleDayOrderGuide) {
            var deliveryDate = moment(Date.now() + 1 * 24 * 3600 * 1000);
        }
        else {
            deliveryDate = this.state.customDeliveryDate;
        }

        var data = {
            "SalesOrderItems": rows,
            "DeliveryDate": deliveryDate.format(), // Browser datetime with timezone
            "IsSave": isSave,
            "LastPublishedDate": this.state.lastPublishedDate,
            "OrderGuideGroupId": this.state.orderGuideGroup.orderGuideGroupId
        };

        const fetchConfig = {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        };
        const response = await fetch('api/salesorder/submitgrouporder', fetchConfig);
        toast.dismiss();
        if (response.ok) {
            let data2 = await response.json();
            if (data2.serverLastPublishedDate) {
                // At the moment we don't really detect if there are actual conflicts,
                // so this could be misleading. Just note the more recent submission issue.
                //toast.error("Conflicts found.");

                if (!window.confirm("There is a more recent order submission for at least one store. Continue?")) {
                    this.setState({ submitting: false });
                }
                else {
                    //this.setState({
                    //    hasConflicts: true, lastPublishedDate: data2.serverLastPublishedDate
                    //});
                    this.setState({ lastPublishedDate: data2.serverLastPublishedDate });
                    this.postOrder(isSave);
                }
            }
            else {
                toast.success("Sales Orders saved. Refreshing all orders.", { autoClose: 50000, hideProgressBar: false });
                await this.onRefreshOrders(deliveryDate);
                toast.dismiss();
                this.setState({ isDirty: false, submitting: false });
            }
        }
        else {
            toast.error("Unable to save Sales Orders.");
            console.log("Unable to save Sales Orders: " + await response.text());
            this.setState({ responseStatus: response.status, submitting: false });
        }
    }

    saveOrders = async () => {
        this.postOrder(true);
    }

    submitOrders = async () => {
        this.postOrder(false);
    }

    orderSubmisionClosingWarning = async () => {
        console.log("close warning fired");

        var now = new Date();
        var close = this.state.closeDate;
        var closeWarning = new Date(close - (5 * 60000));

        // If we are within 5 minutes of the close datetime, show the warning message.
        if (now > closeWarning) {
            this.setState({ orderCloseWarning: true });
        }

        if (now > close) {
            if (this.state.isDirty) {
                this.postOrder(false);
            }

            this.setState({ HoursOfOperationCheck: false, orderCloseWarning: false });
            window.clearInterval(this.state.refreshId);
        }
    }

    onChangeDeliveryDate = async (selectedDate) => {
        if (this.state.isDirty && !window.confirm("Changes to all Sales Orders will be lost. Continue?")) {
            return;
        }
        toast.warn(`Getting orders for ${selectedDate.format('MM/DD/YYYY')}...`, { autoClose: 10000, hideProgressBar: false });
        await this.onRefreshOrders(selectedDate);
        toast.dismiss();
    }

    onRefreshOrders = async (selectedDate) => {
        let topOptions = this.state.gridApi;
        let bottomOptions = this.state.gridApiBottom;

        topOptions.alignedGrids = [];
        bottomOptions.alignedGrids = [];

        topOptions.alignedGrids.push(bottomOptions);
        bottomOptions.alignedGrids.push(topOptions);

        this.setState({
            gridApi: topOptions,
            gridApiBottom: bottomOptions
        });

        const fetchConfig = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        };

        // Browser datetime with timezone
        const response2 = await fetch('api/SalesOrder/SalesOrderGroup?orderDate=' + selectedDate.format(), fetchConfig);
        if (response2.ok) {
            let data2 = await response2.json();
            if (data2.salesOrders && data2.salesOrders.length > 0) {
                //Must reset due to how grid lib tracks pointers to parent state
                await this.setState({ salesOrderItems: [], columns: [], columnsBottom: [] });

                await this.setState({
                    salesOrderItems: data2.salesOrders,
                    columns: data2.agColumns,
                    columnsBottom: data2.agColumnsBottom,
                    // Pacific time
                    orderGuideDeliveryDate: data2.orderGuideDeliveryDate,
                    // Pacific time
                    deliveryDateMax: moment(data2.orderGuideDeliveryDate),
                    // Pacific time
                    customDeliveryDate: selectedDate,
                    // Pacific time
                    originalLastPublishDate: data2.lastPublishedDate,
                    // Pacific time
                    lastPublishedDate: data2.lastPublishedDate,
                    isDirty: false
                });

                if (this.state.gridColumnApi) {
                    var allColumnIds = [];
                    this.state.gridColumnApi.getAllColumns().forEach(function (column) {
                        if (column.colDef.headerName !== "OGC Comments" && column.colDef.headerName !== "Group Buyer Notes") {
                            allColumnIds.push(column.colId);
                        }
                    });
                    this.state.gridColumnApi.autoSizeColumns(allColumnIds);
                }

                if (this.state.originalDeliveryDate.date() !== this.state.customDeliveryDate.date()) {
                    this.setState({ HoursOfOperationCheck: true, openDate: new Date(this.state.originalDeliveryDate.format()), closeDate: new Date(selectedDate.format()) });
                }
                else {
                    let dateNow = new Date();
                    this.setState({ HoursOfOperationCheck: (dateNow > this.state.deepOpenDate && dateNow < this.state.deepCloseDate) ? true : false, openDate: this.state.deepOpenDate, closeDate: this.state.deepCloseDate });
                }
            }
            else {
                toast.warn(`No Order Guide has been created today for ${this.state.orderGuideGroup.orderGuideGroupName}.`);
            }
        }
    }

    refreshBottomRows = () => {
        this.forceUpdate();
    }

    onGridReady = async (params) => {
        this.gridApi = params.api;
        this.gridApi.setHeaderHeight(100);

        params.columnApi.isDirty = this.state.isDirty;

        this.gridColumnApi = params.columnApi;
        this.gridApi.addEventListener('cellEditingStarted', this.setIsDirty);
        this.gridApi.addEventListener('cellValueChanged', this.refreshBottomRows);

        var allColumnIds = [];
        params.columnApi.getAllColumns().forEach(function (column) {
            if (column.colDef.headerName !== "OGC Comments" && column.colDef.headerName !== "Group Buyer Notes") {
                allColumnIds.push(column.colId);
            }
        });
        params.columnApi.autoSizeColumns(allColumnIds);

        await this.setState({ gridApi: this.gridApi, gridColumnApi: this.gridColumnApi });
    }

    onGridReadyBottom = async (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.setHeaderHeight(0);

        await this.setState({ gridColumnApiBottom: this.gridColumnApi, gridApiBottom: this.gridApi });
    }

    onColumnResized(event) {
        if (event.finished) {
            this.gridApi.resetRowHeights();
        }
    }

    setIsDirty = () => {
        this.setState({ isDirty: true });
    }

    navigate = (e) => {
        console.log('navigate pressed');
        e.preventDefault();
        this.setState({ toSalesOrder: true });
    }

    render() {
        if (this.state.toSalesOrder === true) {
            return <Redirect to={{ pathname: '/CreateSalesOrder', state: { groupDeliveryDate: this.state.customDeliveryDate, storeId: "10" } }} />;
        }

        if (this.state.loading) {
            return <p style={{ padding: '10px' }}><em>Loading...</em></p>;
        }

        var d = (this.props.isSameDay) ? new Date() : (this.state.orderGuideGroup.allowMultipleDayOrderGuide) ? new Date(this.state.customDeliveryDate.format()) : new Date(this.state.orderGuideDeliveryDate);
        var monthName = DateConst.months[d.getMonth()];

        const deliveryDate = monthName + " " + d.getDate().toString() + ", " + d.getFullYear().toString();
        const orderAvailable = this.state.HoursOfOperationCheck && this.state.salesOrderItems.length !== 0 && !this.state.loading;
        const orderPublished = this.state.salesOrderItems.length !== 0 && !this.state.loading;
        const allowMultipleDayOrderGuide = !this.props.isSameDay && this.state.orderGuideGroup.allowMultipleDayOrderGuide;

        var rowString = "";
        var rowQuantityString = "";
        var rowPriceString = "";

        if (this.state.salesOrderItems && this.state.cols) {
            for (var i = 0; i < this.state.cols.length; i++) {

                var totalQuantity = 0;
                var totalPrice = 0;
            
                for (var j = 0; j < this.state.salesOrderItems.length; j++) {
                    var quantity = this.state.salesOrderItems[j][this.state.cols[i]];

                    totalQuantity += parseInt(quantity,10) || 0;
                    totalPrice += (parseInt(quantity,10) || 0) * parseFloat((this.state.salesOrderItems[j]["Price"] || "0").toString().replace("$", ""));
                }

                rowQuantityString += ',"' + this.state.cols[i] + '":' + totalQuantity;
                rowPriceString += ',"' + this.state.cols[i] + '": "$' + totalPrice.toFixed(2) + '"';
            } 
        }

        rowString = '[{ "Description": "Total Cases"' + rowQuantityString + '}' + ((this.state.orderGuideGroup.showPricing) ?  ', { "Description": "Total Price"' + rowPriceString + '}' : '') +']';
  
        var rowDataBottom = JSON.parse(rowString);

        return (
            <div className="ag-theme-balham">
                {!this.state.loading &&
                    <PageHeader pageTitle={this.props.isSameDay === true ? "Same Day Sales Order" : "Sales Order"}
                        pageHeaderCenter={
                            <PageHeaderCenter>
                                <span>Delivery for </span> {deliveryDate}
                            </PageHeaderCenter>
                        }
                        pageHeaderRight={
                            <PageHeaderRight>
                                {allowMultipleDayOrderGuide &&
                                    <div style={{ marginRight: '10px', display: 'inline-block', height: '20px' }} >
                                        <span>Set Delivery Date: </span>
                                        <SingleDatePicker
                                            date={this.state.customDeliveryDate}
                                            onDateChange={customDeliveryDate => this.onChangeDeliveryDate(customDeliveryDate)}
                                            focused={this.state.focused}
                                            onFocusChange={({ focused }) => this.setState({ focused })}
                                            id="your_unique_id"
                                            isOutsideRange={(currDate) => currDate.isBefore(this.state.startDeliveryDate, 'day') || currDate.isAfter(this.state.deliveryDateMax, 'day')}
                                            numberOfMonths={1}
                                            readOnly
                                        />
                                    </div>
                                }
                            </PageHeaderRight>
                        }
                    />
                }
                {this.state.orderCloseWarning &&
                    <div className="problem" style={{ height: '25px' }}>
                        <div>
                            <div style={{ display: 'inline-block', color: 'white', textAlign: 'center' }}>
                                <div style={{ fontSize: '16px' }}>
                                    <span>Please complete your order. Submission closes at </span>
                                    {this.props.isSameDay === true &&
                                        this.state.orderGuideGroup.sameDayOrderHoO_End
                                    }
                                    {this.props.isSameDay === false &&
                                        this.state.orderGuideGroup.orderHoO_End
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {!orderPublished &&
                    <div>
                        <h3>Order Guide has not been published.</h3>
                    </div>
                }
                {!orderAvailable &&
                    <div>
                        {this.state.salesOrderItems.length !== 0 &&
                            <h2>Sorry. Sales Orders are closed for the day.</h2>
                        }
                        <h3>Please contact your OGC Sales rep.</h3>
                    </div>
                }
                {orderAvailable &&
                    <React.Fragment>
                        <div>
                            <div className="groupOrderScrollContainer" style={{ height: '67vh' }}>
                                <AgGridReact
                                    gridOptions={this.state.gridApi}
                                    columnDefs={this.state.columns}
                                    rowData={this.state.salesOrderItems}
                                    frameworkComponents={this.state.frameworkComponents}
                                    onColumnResized={this.onColumnResized.bind(this)}
                                    onGridReady={this.onGridReady.bind(this)}
                                    suppressColumnVirtualisation
                                    suppressHorizontalScroll
                                    rowBuffer={5000}
                                    suppressPropertyNamesCheck
                                    suppressColumnMoveAnimation
                                />
                            </div>
                            <div style={{ height: '80px', marginRight: '16px' }}>
                                <AgGridReact
                                    gridOptions={this.state.gridApiBottom}
                                    columnDefs={this.state.columnsBottom}
                                    rowData={rowDataBottom}
                                    onColumnResized={this.onColumnResized.bind(this)}
                                    onGridReady={this.onGridReadyBottom.bind(this)}
                                    suppressColumnVirtualisation
                                    suppressPropertyNamesCheck
                                    suppressColumnMoveAnimation
                                />
                            </div>
                        </div>
                        {!this.state.orderSubmitted &&
                            <div className="problem">
                                <div>
                                    <div style={{ display: 'inline-block' }}>
                                        <input type="button" className={(this.state.isDirty) ? "orderGuideButton" : "orderGuideDisbledButton"} onClick={this.saveOrders} value="Save All Orders" disabled={this.state.submitting || !this.state.isDirty} />
                                        <input type="button" className="orderGuideButton" onClick={this.submitOrders} value="Submit All Orders" disabled={this.state.submitting} />
                                    </div>
                                </div>
                            </div>
                        }
                    </React.Fragment>
                }
                <SupportTeam isEditHome={false} />
                <Prompt when={this.state.isDirty} message="Changes to all Sales Orders will be lost. Continue?" />
            </div>
        );
    }
}

export default withRouter(connect(state => state.login,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(CreateSalesOrderGroup));

const KEY_BACKSPACE = 8;
const KEY_DELETE = 46;
const KEY_F2 = 113;

export class NumericEditor extends Component {
    constructor(props) {
        super(props);

        this.cancelBeforeStart = this.props.charPress && ('1234567890'.indexOf(this.props.charPress) < 0);

        this.state = this.createInitialState(props);

        this.onKeyDown = this.onKeyDown.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.refs.input.addEventListener('keydown', this.onKeyDown);

    }

    componentWillUnmount() {
        this.refs.input.removeEventListener('keydown', this.onKeyDown);
    }

    createInitialState(props) {
        let startValue;
        let highlightAllOnFocus = true;

        if (props.keyPress === KEY_BACKSPACE || props.keyPress === KEY_DELETE) {
            // if backspace or delete pressed, we clear the cell
            startValue = '';
        } else if (props.charPress) {
            // if a letter was pressed, we start with the letter
            startValue = props.charPress;
            highlightAllOnFocus = false;
        } else {
            // otherwise we start with the current value
            startValue = props.value;
            if (props.keyPress === KEY_F2) {
                highlightAllOnFocus = false;
            }
        }

        return {
            value: startValue,
            highlightAllOnFocus
        };
    }
  
    afterGuiAttached() {
        console.log('h', this.state.highlightAllOnFocus);
        // get ref from React component
        const eInput = this.refs.input;
        eInput.focus();
        if (this.state.highlightAllOnFocus) {
            //eInput.select();

            this.setState({
                highlightAllOnFocus: false
            });
        } else {
            // when we started editing, we want the carot at the end, not the start.
            // this comes into play in two scenarios: a) when user hits F2 and b)
            // when user hits a printable character, then on IE (and only IE) the carot
            // was placed after the first character, thus 'apply' would end up as 'pplea'
            const length = eInput.value ? eInput.value.length : 0;
            if (length > 0) {
                eInput.setSelectionRange(length, length);
            }
        }
    }

    getValue() {
        return this.state.value;
    }

    isCancelBeforeStart() {
        return this.cancelBeforeStart;
    }

    // will reject the number if it greater than 1,000,000
    // not very practical, but demonstrates the method.
    isCancelAfterEnd() {
        return this.state.value > 1000000;
    }

    onKeyDown(event) {
        if (this.isLeftOrRight(event) || this.deleteOrBackspace(event) || this.isBottomRow(event)) {
            event.stopPropagation();
            return;
        }

        if (!this.isKeyPressedNumeric(event)) {
            if (event.preventDefault) event.preventDefault();
        }
    }

    isLeftOrRight(event) {
        return [37, 39].indexOf(event.keyCode) > -1;
    }

    isBottomRow(event) {
        var model = this.props.api.getModel();
        var rows = model.rowsToDisplay.length;
        var index = this.props.rowIndex;

        if (index + 1 === rows) {
            return [40].indexOf(event.keyCode) > -1;
        }
        else {
            return false;
        }
    }

    handleChange(event) {
        this.setState({ value: event.target.value });
    }

    getCharCodeFromEvent(event) {
        event = event || window.event;
        return (typeof event.which === "undefined") ? event.keyCode : event.which;
    }

    isCharNumeric(charStr) {
        return !!/\d/.test(charStr);
    }

    isKeyPressedNumeric(event) {
        const charCode = this.getCharCodeFromEvent(event);
        const charStr = event.key ? event.key : String.fromCharCode(charCode);
        return this.isCharNumeric(charStr);
    }

    deleteOrBackspace(event) {
        return [KEY_DELETE, KEY_BACKSPACE].indexOf(event.keyCode) > -1;
    }

    render() {
        return (
            <input ref="input"
                value={this.state.value || null}
                onChange={this.handleChange}
                style={{ width: "100%" }}
            />
        );
    }
}

export class CustomHeader extends Component {
    constructor(props) {
        super(props);

        props.reactContainer.style.display = "inline-block";

        this.state = {
            ascSort: 'inactive',
            descSort: 'inactive',
            noSort: 'inactive',
            hide: 'false'
        };
    }

    navigate = (e) => {
        e.preventDefault();

        if (this.props.isDirty) {
            if (!window.confirm("Changes to all Sales Orders will be lost. Continue?")) {
                this.setState({ toSalesOrder: false });

                return;
            }
            else {
                this.setState({ toSalesOrder: true });
            } 
        }
        else {
            this.setState({ toSalesOrder: true });
        }  
    }

    hideFields = () => {
        var gridColumnApi = this.props.columnApi;

        gridColumnApi.getAllColumns().forEach(function (column) {
            if ((column.colDef.headerName === "OGC Comments" && column.colDef.available) ||
                (column.colDef.headerName === "Group Buyer Notes" && column.colDef.available)||
                (column.colDef.headerName === "Brand" && column.colDef.available) ||
                (column.colDef.headerName === "Price" && column.colDef.available)
               ) {
                gridColumnApi.setColumnVisible(column.colId, !column.visible);
            }
        });
        this.setState({ hide: !this.state.hide });
    }

    render() {
        if (this.state.toSalesOrder === true) {
            return <Redirect to={{ pathname: '/CreateSalesOrder', state: { groupDeliveryDate: this.props.column.colDef.orderDate, storeId: this.props.column.colId } }} />;
        }

        const navigatable = (this.props.displayName === "ProductId" ||
            this.props.displayName === "StoreId" ||
            this.props.displayName === "Description" ||
            this.props.displayName === "Price" ||
            this.props.displayName === "OGC Comments" ||
            this.props.displayName === "Brand" ||
            this.props.displayName === "SortValue" ||
            this.props.displayName === "ProductClass" ||
            this.props.displayName === "Packaging" ||
            this.props.displayName === "Group Buyer Notes" ||
            this.props.displayName === "Total Cases" ||
            this.props.displayName === "Total Price"); 

        return (
                <React.Fragment>             
                {navigatable &&
                    <div className="ag-cell-label-container" role="presentation" style={{ textAlign: 'left', width: '100%', height: '100%' }}> 
                        <span ref="eText" className="ag-header-cell-text" role="columnheader" style={{ color: 'black', fontWeight: 'bold', textAlign: 'left', width: '100%' }}>{this.props.displayName}</span>
                        {this.props.displayName === "Description" &&
                            <button className="ogcButton" onClick={this.hideFields} style={{float:'right', height:'30px'}}> {this.state.hide && "<<"} {!this.state.hide && ">>"} </button>
                        }
                    </div>
                }
                {!navigatable &&
                    <div className="ag-cell-label-container" role="presentation" style={{ backgroundColor: (this.props.column.colDef.published === 2 ? 'lightgreen' : (this.props.column.colDef.published === 1 ? 'lightyellow' : ''))}}>
                        <div style={{ transform: 'rotate(90deg)', marginTop: '0px', textAlign: 'center', minWidth: '80px', paddingTop: '40px' }}>
                            <a href="/" className="customHeaderLabel" onClick={this.navigate} style={{ height: '100%', width: '100px' }}>{this.props.displayName}</a>
                        </div>
                    </div>
                }
                </React.Fragment>           
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/SalesOrderGroup/CreateSalesOrderGroup.js